import React, { useState } from 'react';
import { HandIcon, MailIcon, SparklesIcon } from 'lucide-react';
import { ArchiveTile } from '../../components/archive/ArchiveTile';
import { ArchiveDetail } from '../../components/archive/ArchiveDetail';
import { InitialAvatar } from '../../components/InitialAvatar';
import { ARCHIVE_ITEMS } from '../../data/archive';
import type { ArchiveItem } from '../../data/archive';
import { VOICES_ISSUES } from '../../data/voices';
export function Voices() {
  const [issueId, setIssueId] = useState(VOICES_ISSUES[0].id);
  const [openItem, setOpenItem] = useState<ArchiveItem | null>(null);
  const issue = VOICES_ISSUES.find(entry => entry.id === issueId) ?? VOICES_ISSUES[0];
  const backIssues = VOICES_ISSUES.filter(entry => entry.id !== issue.id);
  const featured = issue.featured.map(id => ARCHIVE_ITEMS.find(item => item.id === id)).filter((item): item is ArchiveItem => Boolean(item));
  return <div className="min-h-full bg-card" data-id="element-904" data-mp="3tevbdds2t2p0">
      {/* Same off-white band as People and Archive. */}
      <div className="border-b border-rule bg-canvas" data-id="element-905" data-mp="3u0zvne9r1plk">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 px-4 py-6 sm:px-6" data-id="element-906" data-mp="2t5afgfyptn6">
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2" data-id="element-907" data-mp="3kz0gkriaovl9">
            <div className="flex flex-wrap items-baseline gap-x-3" data-id="element-908" data-mp="3l1ctgq974frg">
              <h1 className="text-section-heading font-semibold text-ink" data-id="element-909" data-mp="3pwjrbhfsaq8g">Voices</h1>
              <p className="text-small text-ink-muted" data-id="element-910" data-mp="3b85pn9u3t7th">
                The monthly letter, as it went out by email
              </p>
            </div>
            <span className="inline-flex shrink-0 items-center gap-2 rounded-pill border border-rule px-3.5 py-1.5 text-small text-ink-muted" data-id="element-911" data-mp="328ipssh0wa2j">
              <MailIcon aria-hidden="true" className="h-4 w-4" data-id="element-912" data-mp="36b5l53cwkd4h" />
              You receive this
            </span>
          </div>
        </div>
      </div>

      {/* THE ISSUE — one at a time, read like a letter. */}
      <article className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6" data-id="element-913" data-mp="2x8wcyk53wvu9">
        <header className="flex flex-col gap-4 border-b border-rule pb-6" data-id="element-914" data-mp="12th3qgmnaq6h">
          <span className="flex items-center gap-2 text-eyebrow-caption font-semibold uppercase text-ink-muted" data-id="element-915" data-mp="y2r13b5lt1fh">
            <span aria-hidden="true" className="h-px w-5 bg-highlight" data-id="element-916" data-mp="u0dvqnurr5j8" />
            {issue.month}
          </span>
          <h2 className="text-display font-semibold text-ink" data-id="element-917" data-mp="p2vkurx6yg8l">{issue.title}</h2>
          <div className="flex items-center gap-3" data-id="element-918" data-mp="1lslafiqps7uz">
            <InitialAvatar name={issue.author.name} size={40} data-id="element-919" data-mp="1lra5hflj8u2a" />
            <span className="flex flex-col" data-id="element-920" data-mp="1hrja0yl29prf">
              <span className="text-body font-medium text-ink" data-id="element-921" data-mp="1honc3a97r12z">{issue.author.name}</span>
              <span className="text-small text-ink-muted" data-id="element-922" data-mp="1cths4gzdfwhj">{issue.author.role}</span>
            </span>
          </div>
        </header>

        <div className="flex flex-col gap-5 py-6" data-id="element-923" data-mp="1byk8bauj5cn">
          {issue.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} className="text-body leading-relaxed text-ink" data-id="element-924" data-mp="3sisyjauka6bo">
              {paragraph}
            </p>)}
        </div>

        {featured.length > 0 ? <section aria-labelledby="featured" className="border-t border-rule pt-6" data-id="element-925" data-mp="3ndfmjylbspe9">
            <h3 id="featured" className="text-heading font-semibold text-ink" data-id="element-926" data-mp="3scs8mh4dhsfs">
              What we&apos;re pointing at this month
            </h3>
            <ul className="mt-4 columns-1 gap-4 sm:columns-2 [&>li]:mb-4" data-id="element-927" data-mp="ywai8jtpmay">
              {featured.map(item => <ArchiveTile key={item.id} item={item} onOpen={setOpenItem} data-id="element-928" data-mp="4zg5p6ku6fug" />)}
            </ul>
          </section> : null}

        {issue.updates.length > 0 ? <section aria-labelledby="issue-updates" className="mt-6 flex flex-col gap-4 rounded-card border border-rule bg-canvas p-5" data-id="element-929" data-mp="ez6yn3tr0msf">
            <h3 id="issue-updates" className="flex items-center gap-2 text-heading font-semibold text-ink" data-id="element-930" data-mp="2gq0m0d9za8az">
              <SparklesIcon aria-hidden="true" className="h-4 w-4 text-primary-text" data-id="element-931" data-mp="2lqfx0y6sf3ps" />
              New in the portal
            </h3>
            <ul className="flex flex-col divide-y divide-rule" data-id="element-932" data-mp="b18agdpf0xrs">
              {issue.updates.map(update => <li key={update.title} className="flex flex-col gap-1 py-3 first:pt-0 last:pb-0" data-id="element-933" data-mp="p0zlc5kmxy1k">
                  <span className="text-body font-medium text-ink" data-id="element-934" data-mp="k1elzu1jznob">{update.title}</span>
                  <span className="text-small text-ink-muted" data-id="element-935" data-mp="3sgybqj30mnym">{update.body}</span>
                </li>)}
            </ul>
          </section> : null}

        <p className="mt-6 border-t border-rule pt-6 text-body italic text-ink-muted" data-id="element-936" data-mp="3oe1nabqsnxmr">
          {issue.signoff}
        </p>
        <p className="mt-1 text-small text-ink-muted" data-id="element-937" data-mp="1beyvcp9winj">
          {issue.author.name}, {issue.author.role.toLowerCase()}
        </p>
      </article>

      {/* BACK ISSUES */}
      <section aria-labelledby="back-issues" className="border-t border-rule bg-canvas" data-id="element-938" data-mp="39olz93ine6ar">
        <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6" data-id="element-939" data-mp="34psvi2t5xtns">
          <h2 id="back-issues" className="text-heading font-semibold text-ink" data-id="element-940" data-mp="1k91kfdj678cs">
            Past issues
          </h2>
          <ul className="mt-4 flex flex-col divide-y divide-rule border-t border-rule" data-id="element-941" data-mp="1p1upy3mgqkpx">
            {backIssues.map(entry => <li key={entry.id} data-id="element-942" data-mp="1g89ccnm1b9i3">
                <button type="button" onClick={() => {
              setIssueId(entry.id);
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }} className="flex w-full flex-col gap-0.5 py-4 text-left hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-943" data-mp="1g9avzgh494bf">
                  <span className="text-small text-ink-muted" data-id="element-944" data-mp="1ywwf2zgqnmsi">{entry.month}</span>
                  <span className="text-body font-medium text-ink" data-id="element-945" data-mp="ijpmorooeqog">{entry.title}</span>
                  <span className="text-small text-ink-muted" data-id="element-946" data-mp="nklq74548atc">
                    {entry.author.name} · {entry.paragraphs.length}{' '}
                    {entry.paragraphs.length === 1 ? 'note' : 'notes'}
                  </span>
                </button>
              </li>)}
          </ul>
          <p className="mt-5 text-small text-ink-muted" data-id="element-947" data-mp="3qt8t55uggbbu">
            Voices goes out on the first of the month. You can stop receiving it from your
            settings and still read every issue here.
          </p>

          <div className="mt-6 flex flex-col gap-3 rounded-card border border-rule bg-card p-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-948" data-mp="3gxx9qa83qfxr">
            <div className="flex max-w-xl flex-col gap-1" data-id="element-949" data-mp="37ve9zyzm4jfq">
              <p className="text-body font-medium text-ink" data-id="element-950" data-mp="37vxthk4wvfvv">
                Want to help put this together?
              </p>
              <p className="text-small text-ink-muted" data-id="element-951" data-mp="164ayl7hwf0u4">
                The archive group is four volunteers and a scanner. No commitment, no schedule.
              </p>
            </div>
            <a href="#volunteer" className="inline-flex min-h-tap shrink-0 items-center gap-2 rounded-pill bg-primary px-5 text-small font-medium text-on-primary hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-952" data-mp="113dir1kd2ivs">
              <HandIcon aria-hidden="true" className="h-4 w-4" data-id="element-953" data-mp="1ne53gfas7nxv" />
              Get in touch
            </a>
          </div>
        </div>
      </section>

      <ArchiveDetail item={openItem} onClose={() => setOpenItem(null)} data-id="element-954" data-mp="prpmrfq6iubd" />
    </div>;
}